export const CRM_ACTIVITY_KIND_LABELS: Record<string, string> = {
  note: 'Заметка',
  call: 'Звонок',
  meeting: 'Встреча',
  handoff_to_production: 'Передача в производство',
  production_note: 'Производство',
};

export const CRM_ACTIVITY_TEMPLATES = [
  'Дозвонился, ждём ответ',
  'КП отправили',
  'Назначен замер',
  'Клиент думает',
  'Не дозвонился',
];
